import { adminApiClient } from '../lib/apiClient';

function appendIfPresent(formData, key, value) {
  if (value !== undefined && value !== null && String(value).trim() !== '') {
    formData.append(key, String(value).trim());
  }
}

function extractInventory(payload) {
  if (payload?.data && !Array.isArray(payload.data)) {
    return payload.data;
  }

  if (payload?.data?.data && !Array.isArray(payload.data.data)) {
    return payload.data.data;
  }

  if (payload?.inventory && !Array.isArray(payload.inventory)) {
    return payload.inventory;
  }

  return null;
}

export async function getAdminInventory(variantId) {
  const formData = new FormData();
  appendIfPresent(formData, 'variant_id', variantId);

  const response = await adminApiClient.post('/admin/inventory/get', formData);

  return {
    raw: response.data,
    item: extractInventory(response.data),
  };
}

export async function createAdminInventory(payload) {
  const formData = new FormData();
  appendIfPresent(formData, 'variant_id', payload.variant_id);
  appendIfPresent(formData, 'stock', payload.stock);

  const response = await adminApiClient.post('/admin/inventory/create', formData);
  return response.data;
}

export async function updateAdminInventory(payload) {
  const formData = new FormData();
  appendIfPresent(formData, 'inventory_id', payload.inventory_id);
  appendIfPresent(formData, 'stock', payload.stock);
  appendIfPresent(formData, 'reserved_stock', payload.reserved_stock);

  const response = await adminApiClient.post('/admin/inventory/update', formData);
  return response.data;
}

export async function deleteAdminInventory(inventoryId) {
  const formData = new FormData();
  appendIfPresent(formData, 'inventory_id', inventoryId);

  const response = await adminApiClient.post('/admin/inventory/delete', formData);
  return response.data;
}
